(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

    const btn = document.getElementById("order-on-whatsapp");
    if (!btn) return;

    // ===== Config =====
    const WHATSAPP_NUMBER = "923014652759";
    const ADVANCE_DISCOUNT = 300;
    const DELIVERY_CHARGE = 200;        // Rs. — normal delivery charge
    const FREE_DELIVERY_MIN_QTY = 2;    // qty >= this = free delivery
    const PAYMENT_DETAILS = {
        "EasyPaisa": {
            "Account Title": "Asif Maqbool",
            "Account Number": "0303-0848532"
        },
        "JazzCash": {
            "Account Title": "Asif Maqbool",
            "Account Number": "0303-0848532"
        },
        "Advance Bank Transfer": {
            "Bank": "Meezan Bank",
            "Account Title": "Asif Maqbool",
            "Account Number": "02780104376598",
            "IBAN": "PK94MEZN0002780104376598"
        }
    };

    const overlay = document.getElementById("lzOverlay");
    const closeBtn = document.getElementById("lzCloseModal");
    const form = document.getElementById("lzOrderForm");
    const sumProduct = document.getElementById("lzSumProduct");
    const sumSize = document.getElementById("lzSumSize");
    const sumColor = document.getElementById("lzSumColor");
    const sumQty = document.getElementById("lzSumQty");
    const sumPrice = document.getElementById("lzSumPrice");

    // holds the detected product info between "open modal" and "submit"
    let current = { product: "", url: "", price: "", qty: 1, variant: "", color: "", cleanPrice: 0 };

    function detectProduct() {
        let product = document.querySelector("h1")?.innerText.trim() || "";
        let url = window.location.href;

        let price = "";
        let priceElement = document.querySelector("#js-product-price") || document.querySelector(".price, .product-price, .money");
        if (priceElement) price = priceElement.innerText.trim();

        let qty = document.querySelector("#Quantity")
            ? parseInt(document.querySelector("#Quantity").value)
            : 1;

        let variant = "";
        let sizeSection = document.querySelector(".product-options__section[data-property='Size']");
        if (sizeSection) {
            let activeSize = sizeSection.querySelector(".product-options__value.active");
            if (activeSize) variant = activeSize.textContent.trim();
        }

        let color = "";
        let colorSection = document.querySelector(".product-options__section[data-property='Color']");
        if (colorSection) {
            let activeColor = colorSection.querySelector(".product-options__value.active");
            if (activeColor) color = activeColor.getAttribute("data-value") || activeColor.textContent.trim();
        }

        let cleanPrice = parseFloat(
            (price.match(/[\d,]+(\.\d+)?/) || ["0"])[0].replace(/,/g, "")
        ) || 0;

        current = { product, url, price, qty, variant, color, cleanPrice };
        return current;
    }

    function deliveryCharge() {
        return current.qty >= FREE_DELIVERY_MIN_QTY ? 0 : DELIVERY_CHARGE;
    }

    function currentTotal() {
        let total = current.cleanPrice * current.qty;
        total += deliveryCharge();
        if (document.getElementById("lzAdvanceDiscount").checked) total -= ADVANCE_DISCOUNT;
        return total;
    }

    function updateSummary() {
        sumProduct.textContent = current.product;
        sumSize.textContent = current.variant;
        sumColor.textContent = current.color || "-";
        sumQty.textContent = current.qty;
        const total = currentTotal();
        const advChecked = document.getElementById("lzAdvanceDiscount").checked;
        const delivery = deliveryCharge();
        const deliveryText = delivery === 0 ? "Free Delivery 🎉" : "Rs. " + delivery;
        sumPrice.textContent = advChecked
            ? "Delivery: " + deliveryText + " · Total: Rs. " + total.toLocaleString("en-US") + " (Rs. " + ADVANCE_DISCOUNT + " advance discount applied)"
            : "Delivery: " + deliveryText + " · Total: Rs. " + total.toLocaleString("en-US");
    }

    btn.addEventListener("click", function (e) {
        e.preventDefault();
        detectProduct();

        if (current.variant === "") {
            alert("Please select a size before ordering.");
            return;
        }

        updateSummary();
        overlay.classList.add("lz-open");
    });

    closeBtn.addEventListener("click", () => overlay.classList.remove("lz-open"));
    overlay.addEventListener("click", (e) => { if (e.target === overlay) overlay.classList.remove("lz-open"); });
    document.getElementById("lzAdvanceDiscount").addEventListener("change", updateSummary);

    // Highlight selected payment option + show account details
    document.getElementById("lzPayOptions").addEventListener("change", function (e) {
        document.querySelectorAll(".lz-pay-option").forEach(l => l.classList.remove("lz-selected"));
        e.target.closest(".lz-pay-option").classList.add("lz-selected");

        document.querySelectorAll(".lz-pay-details").forEach(box => {
            box.classList.remove("lz-show");
            box.innerHTML = "";
        });

        const method = e.target.value;
        const details = PAYMENT_DETAILS[method];
        if (details) {
            const box = document.getElementById("lzDetails-" + method);
            let html = "";
            Object.entries(details).forEach(([label, value]) => {
                html += `<div class="lz-row"><span class="lz-label">${label}:</span> <span class="lz-value">${value}</span></div>`;
            });
            html += `<div class="lz-screenshot-note">📸 Payment karne ke baad screenshot WhatsApp par bhej dein — is se aapka order jaldi confirm ho jayega.</div>`;
            box.innerHTML = html;
            box.classList.add("lz-show");
        }
    });

    function setError(fieldName, show) {
        const field = form.querySelector(`[data-field="${fieldName}"]`);
        field.classList.toggle("lz-invalid", show);
    }

    form.addEventListener("submit", function (e) {
        e.preventDefault();

        const fullName = document.getElementById("lzFullName").value.trim();
        const mobile = document.getElementById("lzMobile").value.trim();
        const city = document.getElementById("lzCity").value.trim();
        const address = document.getElementById("lzAddress").value.trim();
        const notes = document.getElementById("lzNotes").value.trim();
        const advanceDiscount = document.getElementById("lzAdvanceDiscount").checked;
        const paymentEl = form.querySelector('input[name="lzPayment"]:checked');

        let valid = true;
        setError("name", !fullName); if (!fullName) valid = false;

        const mobileClean = mobile.replace(/[\s-]/g, "");
        const mobileValid = /^03\d{9}$/.test(mobileClean);
        setError("mobile", !mobileValid); if (!mobileValid) valid = false;

        setError("city", !city); if (!city) valid = false;
        setError("address", !address); if (!address) valid = false;
        setError("payment", !paymentEl); if (!paymentEl) valid = false;

        if (!valid) return;

        const total = currentTotal();
        const paymentDetails = PAYMENT_DETAILS[paymentEl.value];

        let text =
`🌸 *LALAZAR SHOP*

Hello Lalazar Team,

I would like to place an order for the following item.

━━━━━━━━━━━━━━━━━━━━

🛍 Product:
${current.product}

💰 Price:
${current.price}

📏 Size:
${current.variant}

🎨 Color:
${current.color || "-"}

🔢 Quantity:
${current.qty}

🚚 Delivery Charges:
${deliveryCharge() === 0 ? "Free Delivery 🎉" : "Rs. " + deliveryCharge()}

💵 Estimated Order Value:
Rs. ${total.toLocaleString("en-US")}

🔗 Product Link:
${current.url}

━━━━━━━━━━━━━━━━━━━━

📍 *Shipping Information*

👤 Full Name:
${fullName}

📱 Mobile Number:
${mobile}

🏙 City:
${city}

📍 Complete Address:
${address}

━━━━━━━━━━━━━━━━━━━━

💳 *Payment Method:*
${paymentEl.value}
${paymentDetails ? "💼 Pay to: " + Object.entries(paymentDetails).map(([k, v]) => k + ": " + v).join(" | ") : ""}
${paymentDetails ? "📸 I will share the payment screenshot here for confirmation." : ""}

━━━━━━━━━━━━━━━━━━━━

🎁 *Advance Payment Discount:*
${advanceDiscount ? "Yes, applied — Rs. " + ADVANCE_DISCOUNT + " off" : "No"}

━━━━━━━━━━━━━━━━━━━━

📝 *Additional Notes*
${notes || "-"}

━━━━━━━━━━━━━━━━━━━━

Kindly confirm the availability and process my order.

Thank you for your assistance.

🌸 *LalazarShop.com*`;

        window.open(
            "https://wa.me/" + WHATSAPP_NUMBER + "?text=" + encodeURIComponent(text),
            "_blank"
        );

        overlay.classList.remove("lz-open");
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
